import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Page } from '../../@types/ElasticSearchResponse';

interface PaginationProps {
  pages?: Page[] | null;
  onApplyPage: (query: string) => void;
}

const Pagination = ({ pages, onApplyPage }: PaginationProps) => {
  const { t } = useTranslation(['search']);

  if (!pages?.length) {
    return null;
  }

  let prevPage: Page | null = null;
  let nextPage: Page | null = null;

  for (let i = 0; i < pages.length; i++) {
    if (i > 0 && pages[i].selected) {
      prevPage = pages[i - 1];
    }
    if (i < pages.length - 1 && pages[i].selected) {
      nextPage = pages[i + 1];
    }
  }

  let prev = (
    <div className="pagination-prev-container">
      <button
        type="button"
        className="pagination-step is-disabled"
        aria-label={t('goToPreviousPage', { ns: 'search' })}
      >
        <div data-am-icon="primary hover">
          <i className="icon-chevron-left" />
        </div>
      </button>
    </div>
  );

  let next = (
    <div className="pagination-next-container">
      <button
        type="button"
        className="pagination-step is-disabled"
        aria-label={t('goToNextPage', { ns: 'search' })}
      >
        <div data-am-icon="primary hover">
          <i className="icon-chevron-right" />
        </div>
      </button>
    </div>
  );

  if (prevPage) {
    prev = (
      <div className="pagination-prev-container">
        <button
          type="button"
          className="pagination-step"
          onClick={() => onApplyPage(prevPage?.query || '')}
          aria-label={t('goToPreviousPage', { ns: 'search' })}
        >
          <div data-am-icon="primary hover">
            <i className="icon-chevron-left" />
          </div>
        </button>
      </div>
    );
  }
  if (nextPage) {
    next = (
      <div className="pagination-next-container">
        <button
          type="button"
          className="pagination-step"
          onClick={() => onApplyPage(nextPage?.query || '')}
          aria-label={t('goToNextPage', { ns: 'search' })}
        >
          <div data-am-icon="primary hover">
            <i className="icon-chevron-right" />
          </div>
        </button>
      </div>
    );
  }

  return (
    <div data-am-pagination>
      {prev}
      {next}
      <ul className="pagination-list">
        {pages.map((page) => (
          <li
            className={page.selected ? 'pagination-item is-active' : 'pagination-item'}
            key={page.query}
          >
            <button
              type="button"
              className="pagination-btn"
              onClick={() => onApplyPage(page.query)}
              title={t('pageIndex', { ns: 'search', index: page.displayName })}
              aria-label={t('goToPageX', { ns: 'search', index: page.displayName })}
            >
              {page.displayName}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Pagination;
